// The unretryable-extraction notice.
//
// Sits under a reply whose extraction failed in a way retrying cannot fix. It is
// deliberately quieter than the error bubble — the assistant did answer, and the
// only thing lost is the fill — but it is never absent, because a student who
// volunteered details would otherwise assume they were recorded. That is the
// receipts principle applied to a fill that did not happen.
//
// No retry action by design: the same message through the same defect fails the
// same way, so the honest suggestion is to rephrase.
//
// `partial` (platform tracker 6.17): the turn also carried fills, so receipts
// render beside this notice — the copy must not claim nothing was recorded.

import { PARTIAL_FILL_NOTICE, UNRECORDED_FILL_NOTICE } from './constants';
import styles from './ConversationalForms.module.css';
import { AlertIcon } from './icons';

const FillNotice = ({ partial = false }: { partial?: boolean }) => (
    <p className={styles.fillNotice} data-testid="cf-fill-notice">
        <AlertIcon size={12} />
        <span>{partial ? PARTIAL_FILL_NOTICE : UNRECORDED_FILL_NOTICE}</span>
    </p>
);

export default FillNotice;
